import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './Atoms/ErrorBoundary';

interface PageErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Route-scoped error boundary. Keyed on the current pathname so that navigating
 * to a different page automatically unmounts the boundary (clearing any error
 * state) and lets the next page mount cleanly. This guarantees that an error
 * in one page does not block navigation to others.
 */
export const PageErrorBoundary = ({ children }: PageErrorBoundaryProps) => {
  const location = useLocation();
  return (
    <ErrorBoundary
      key={location.pathname}
      scope={`route:${location.pathname}`}>
      {children}
    </ErrorBoundary>
  );
};

export default PageErrorBoundary;
